<template>
  <div>
    <v-col cols="12">
      <v-autocomplete
        rounded
        filled
        label="Output format"
        :items="outputFormats"
        v-model="outPutFormat"
      ></v-autocomplete>
    </v-col>
    <v-col cols="12">
      <div class="code-container">
        <code id="codeblock">
          <div v-if="copied" id="animated-example" class="animated-copied fadeOut caption">
            Copied
            <v-icon class="white--text caption">mdi-check</v-icon>
          </div>
          {{ apiCode.replace(/scripX/g, 'script') }}
          <button
            type="button"
            v-clipboard:copy="apiCode.replace(/scripX/g, 'script')"
            v-clipboard:success="onCopy"
            class="copy-code">Copy</button>
        </code>
      </div>
    </v-col>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { initialConfig } from '@/utils/initialConfig'
import { getCleanConfigs, getCleanThemes, initialTheme, getAttributesAsObject } from '@/utils/helpers'

export default {
  name: 'Code-snippets',
  data: () => ({
    outPutFormat: 'Javascript',
    copied: false,
    outputFormats: [
      'Javascript',
      'Html',
      'JSON',
      'MerchantCashierConfig XML'
    ]
  }),
  computed: {
    ...mapState({
      config: ({ context }) => context.config,
      theme: ({ theme }) => theme.theme,
      customCss: ({ theme }) => theme.customCss,
      preset: ({ config }) => config.preset,
      attributes: ({ context }) => context.attributes,
      userAttributes: ({ context }) => context.userAttributes
    }),
    renderCustomCss () {
      return `\`
  ${this.customCss && this.customCss[this.preset]}
\``
    },
    getAttributesAndUser () {
      return getAttributesAsObject(this.attributes, this.userAttributes)
    },
    getConfigs () {
      const cleanConfigs = getCleanConfigs(initialConfig, this.config)
      const cleanTheme = getCleanThemes(initialTheme, this.theme)
      const config = {
        merchantId: 1000,
        userId: 123,
        sessionId: 123,
        environment: 'test',
        ...this.attributes && { attributes: { ...this.getAttributesAndUser.attributes } },
        ...this.userAttributes && { user: { ...this.getAttributesAndUser.user } },
        ...cleanConfigs,
        theme: {
          ...cleanTheme
        }
      }
      return JSON.stringify(config, null, '\t')
    },
    jsEx () {
      return `
var CashierInstance = new _PaymentIQCashier('#cashier',
${this.getConfigs},
  (api) => {    
    api.on({
      update: data => console.log('The passed in data was set', data),
      success: data => console.log('Transaction was completed successfully', data),
      failure: data => console.log('Transaction failed', data),
      isLoading: data => console.log('Data is loading', data),
      doneLoading: data => console.log('Data has been successfully downloaded', data),
      newProviderWindow: data => console.log('A new window / iframe has opened', data)
    }),
  api.css(${this.renderCustomCss})
})
`
    },
    htmlEx () {
      return `
<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<meta http-equiv="X-UA-Compatible" content="ie=edge">
<title>Cashier HTML Example</title>
<scripX type=text/javascript src='https://checkout.paymentiq.io/cashier/cashier.js'></scripX>
<style> html, body { margin: 0px; } #cashier { height: 100vh; }</style>
</head>
<body>

  <div id="cashier"></div>

<scripX>
 ${this.jsEx}
</scripX>

</body>
</html>
`
    },
    jsonFormat () {
      return `${this.getConfigs}`
    },
    merchantCashierConfigFormat () {
      return `
<com.devcode.paymentiq.service.cashier.MerchantCashierConfig>
    <enabled>true</enabled>
    <checkIfFirstDeposit>false</checkIfFirstDeposit>
    <config>
${this.cashierConfigFormatFilter(this.getConfigs)}
    </config>
    <css>
${this.renderCustomCss.replace(/`/g, '')}
    </css>
</com.devcode.paymentiq.service.cashier.MerchantCashierConfig>
      `
    },
    apiCode () {
      switch (this.outPutFormat) {
        case 'Html':
          return this.htmlEx
        case 'JSON':
          return this.jsonFormat
        case 'MerchantCashierConfig XML':
          return this.merchantCashierConfigFormat
        case 'Javascript':
        default:
          return this.jsEx
      }
    }
  },
  methods: {
    cashierConfigFormatFilter (configs) {
      const cloned = JSON.parse(configs)
      delete cloned.environment
      delete cloned.environment
      delete cloned.merchantId
      delete cloned.userId
      delete cloned.sessionId
      delete cloned.fetchConfig
      return JSON.stringify(cloned, null, '\t')
    },
    onCopy (e) {
      console.log(e.text)
      this.copied = true
      setTimeout(() => {
        this.copied = false
      }, 2000)
    }
  }
}
</script>

<style scoped>
code {
  width: 70vw;
  max-width: 800px;
  padding: 10px;
}
</style>
